import telegramUser from './content-type/telegram-user';
import telegramUserActivity from './content-type/telegram-user-activity';
import telegramGroup from './content-type/telegram-group';
import telegramLink from './content-type/telegram-link';
import deployment from './api/deployment';
import telegramAuth from './api/telegram-auth';
import userActivity from './api/user-activity';

export default {
  'telegram-user': telegramUser,
  'telegram-group': telegramGroup,
  'telegram-link': telegramLink,
  'telegram-user-activity': telegramUserActivity,
  'user-activity': userActivity,
  deployment,
  telegramAuth
}
